import { SCOUTING_TAGS } from '@/types/log-entry';
import { formatTagLabel } from '@/utils/format-utils';

import { TagChip } from '@/components/scouting/TagChip';

interface TagSelectorProps {
  selected: string[];
  onChange: (tags: string[]) => void;
}

export function TagSelector({ selected, onChange }: TagSelectorProps) {
  function handleToggle(tag: string) {
    if (selected.includes(tag)) {
      onChange(selected.filter((t) => t !== tag));
    } else {
      onChange([...selected, tag]);
    }
  }

  return (
    <div className="flex flex-wrap gap-2">
      {SCOUTING_TAGS.map((tag) => {
        const isSelected = selected.includes(tag);
        return (
          <TagChip
            key={tag}
            label={formatTagLabel(tag)}
            state={isSelected ? 'selected' : 'unselected'}
            onClick={() => handleToggle(tag)}
          />
        );
      })}
    </div>
  );
}
